import styled from 'styled-components';

export const TableContainer = styled.div``;

export const ConfigureButton = styled.button`
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid #d4d8dd;
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 113px;
  height: 32px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8fafc;
  }
`;

export const ConfigureIcon = styled.img`
  width: 14px;
  height: 14px;
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 10px;
  border-radius: 20px;
  width: fit-content;
  background: ${({ $isActive }) => ($isActive ? '#FFFFFF' : '#F8FAFC')};
  border: ${({ $isActive }) => ($isActive ? '1px solid #15C7A7' : 'none')};
`;

export const StatusText = styled.p`
  margin: 0;
  color: ${({ $isActive }) => ($isActive ? '#15C7A7' : '#62748E')};
  font-size: 14px;
  font-weight: 500;
`;
